import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    homepage: {
        paddingTop: 50,
        color: 'white',
        overflowX: 'hidden',
        backgroundColor: theme.colors.black,
    },
    bg: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.colors.black,
    },
    img: (props: { image }) => ({
        opacity: 0.5,
        backgroundImage: `linear-gradient(to bottom, rgba(14, 17, 23, 0.32), rgba(14, 17, 23, 0) 17%, rgba(14, 17, 23, 0) 51%, rgba(14, 17, 23, 0.8)), url(${props.image})`,
        filter: 'blur(50px)',
        backgroundSize: 'cover',
        height: '100%',
        '@media (max-width: 767px)': {
            height: '30vh',
        },
    }),
    content: {
        minHeight: '100vh',
        maxWidth: 1440,
        margin: '0 auto',
    },
    section: {
        position: 'relative',
        zIndex: 1,
        padding: '0 78px',
        '&:first-child': {
            paddingTop: 120,
            paddingBottom: 180,
        },
        '@media(max-width: 1023px)': {
            padding: 40,
        },
        '@media (max-width: 767px)': {
            padding: 20,
            paddingTop: 48,
            '&:first-child': {
                paddingTop: 48,
                paddingBottom: 76,
            },
        },
    },
    showCardSection: {
        padding: '0 0 120px 0',
        '@media (max-width: 767px)': {
            paddingBottom: 48,
        },
    },
}))
